import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IconButton, Tooltip, TableCell } from '@material-ui/core';
import { showMessage } from 'app/store/fuse/messageSlice';
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';
import TaskManagerService from 'app/admin/taskManager/service/TaskManagerService';

function TaskManagerClearStateButton(props) {
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const handleDelete = () => {
        setLoading(true);
        TaskManagerService.clearState(props.item.name)
            .then(resp => {
                setLoading(false);
                if (!resp) {
                    dispatch(showMessage({ message: 'Error while clearing state' }));
                } else {
                    dispatch(showMessage({ message: `State successfully cleared` }));
                }
                dispatch({ type: `${props.config.key}/event/setNeedDataReload` });
            })
            .catch(resp => {
                setLoading(false);
                dispatch(showMessage({ message: 'Error while clearing state' }));
                dispatch({ type: `${props.config.key}/event/setNeedDataReload` });
            });
    };

    return (
        <TableCell className='w-auto text-center' padding='none'>

            <Tooltip title='Clear State'>
                <span>
                    <IconButton disabled={!props.item.state} onClick={e => { setShowDeleteConfirm(true) }}>
                        <RemoveCircleOutline fontSize='small' />
                    </IconButton>
                </span>
            </Tooltip>

            <ConfirmDialog show={showDeleteConfirm} title="Clear" description="Do you want to clear the state?" onYes={() => handleDelete()} onClose={() => setShowDeleteConfirm(false)} />

        </TableCell>
    );
}

export default TaskManagerClearStateButton;